'use strict';

var url = require('../../../../../utils/common/url.js');
var ExlyImage_constants = require('../constants/ExlyImage.constants.js');
var isImageFromOptimizingCdn = require('./isImageFromOptimizingCdn.js');

/**
 * get the optimsed image url by appending search params format as "auto"
 * where auto formats fetches the best case format as per transformations and
 * quality as default.
 */
var getOptimisedImageUrl = function (_a) {
    var imageUrl = _a.imageUrl, fetchWidth = _a.fetchWidth, cdnBaseUrl = _a.cdnBaseUrl, _b = _a.format, format = _b === void 0 ? ExlyImage_constants.IMAGE_CDN_FORMATS.AUTO : _b, quality = _a.quality;
    return isImageFromOptimizingCdn.isImageFromOptimizingCdn(imageUrl, cdnBaseUrl)
        ? url.appendURLSearchParams(imageUrl, {
            format: format,
            width: fetchWidth,
            quality: quality,
        })
        : imageUrl;
};

exports.getOptimisedImageUrl = getOptimisedImageUrl;
//# sourceMappingURL=getOptimisedImageUrl.js.map
